module.exports = {
      id: "comm-women-usage",
      viewBox: "0 0 228.124 50.336",
      url: "/" + "sprite-036dd45d0e77a995aefc8cbeaab2becc.svg#comm-women",
      toString: function () {
        return this.url;
      }
    }